import React from 'react';
//MUI components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { countryOptions, stateOptions } from '../../constants/profileData';
import SelectInput from '../../common/SelectInput';

function PersonalDetails({
	firstName,
	lastName,
	age,
	gender,
	city,
	state,
	country,
	handleChange,
	data,
}) {
	return (
		<React.Fragment>
			<Grid container spacing={3}>
				{/* First Name  */}
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id='firstName'
						name='firstName'
						error={data['firstName'].error}
						helperText={
							data['firstName'].error
								? data['firstName'].helperText
								: ''
						}
						label='First name'
						fullWidth
						variant='standard'
						onChange={handleChange}
						value={firstName}
						placeholder='Enter your first name'
					/>
				</Grid>
				{/* Last Name  */}
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id='lastName'
						name='lastName'
						label='Last name'
						error={data['lastName'].error}
						helperText={
							data['lastName'].error
								? data['lastName'].helperText
								: ''
						}
						fullWidth
						variant='standard'
						onChange={handleChange}
						value={lastName}
						placeholder='Enter your last name'
					/>
				</Grid>
				{/* City */}
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id='city'
						name='city'
						label='City'
						error={data['city'].error}
						helperText={
							data['city'].error ? data['city'].helperText : ''
						}
						fullWidth
						variant='standard'
						onChange={handleChange}
						value={city}
						placeholder='Enter your city'
					/>
				</Grid>
				{/* State */}
				<Grid item xs={12} sm={6}>
					<SelectInput
						name='state'
						label='state'
						value={state}
						handleChange={handleChange}
						fullWidth
						variant='standard'
						placeholder='Select your State'
						options={stateOptions}
					/>
				</Grid>

				{/* Country */}
				<Grid item xs={12} sm={6}>
					<SelectInput
						name='country'
						label='country'
						value={country}
						handleChange={handleChange}
						fullWidth
						variant='standard'
						placeholder='Select your Country'
						options={countryOptions}
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
}

export default PersonalDetails;
